/*============================================================================
  Product Benefit Slider
==============================================================================*/
class ProductBenefitSlider extends HTMLElement {
  constructor() {
    super();

    this.init();
  }

  init() {
    // Set up sliders
    this.sliderBenefits = new Swiper(
      this.querySelector(".benefits-strip-slider"),
      {
        spaceBetween: 20,
        slidesPerView: "auto",
        allowTouchMove: false,
        loop: true,
        autoplay: {
            delay: 1,
            disableOnInteraction: false
        },
        speed: 5000,
      }
    );
  }      
}
customElements.define("benefits-strips-slider", ProductBenefitSlider);


/*============================================================================
  Product Ingredient Slider
==============================================================================*/
class ProductIngredientSlider extends HTMLElement {
  constructor() {
    super();

    this.init();
  }

  init() {
    // Set up sliders
    this.sliderIngredients = new Swiper(
      this.querySelector(".ingredientsSwiperMobile"),{
        //slidesPerView: 1.3,
        slidesPerView: 1,
        //centeredSlides: true,
        loop: true,
        autoplay: {
            delay: 6000,
        },
        // Optional parameters
        pagination: {
            el: document.querySelector('.ingredients .swiper-pagination'),
            clickable: true,
        },
        navigation: {
            nextEl: document.querySelector('.ingredients .swiper-button-next'),
            prevEl: document.querySelector('.ingredients .swiper-button-prev'),
        },        
      }
    );
  }
}
customElements.define("product-ingredients-slider", ProductIngredientSlider);


/*============================================================================
  Product Reviews Slider
==============================================================================*/
class ProductReviewsSlider extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.sliderReviews = new Swiper(this.querySelector(".reviewSwiper"), {
      spaceBetween: 22,
      slidesPerView: 1,
      centeredSlides: true,
      loop: true,
      autoplay: {
        delay: 30000,
      },
      pagination: {
        el: document.querySelector(".reviews .swiper-pagination"),
        clickable: true,
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 24,
        },
        749: {
          slidesPerView: 2.4,
          spaceBetween: 24,
        },
        1200: {
          centeredSlides: false,
          slidesPerView: 4.3,
          spaceBetween: 24,
        },
      },
      on: {
        init: function () {
          this.slideTo(1, 0, false); // 👈 Moves to second slide after init
        },
      },
    });

    // optional: update swiper once page fully loaded (ensures layout is correct)
    window.addEventListener("load", () => this.sliderReviews.update());
  }
}

customElements.define("product-reviews-slider", ProductReviewsSlider);


/*============================================================================
  Reviews Slider
==============================================================================*/
class ReviewsSlider extends HTMLElement {
  constructor() {
    super();

    this.init();
  }

  init() {
    // Set up sliders
    const bigScreenSlides = 2.2;
    const bigScreenGap = 24;
    this.reviewsSlider = new Swiper(
      this.querySelector(".reviewsSlider"),{
        loop: true,
        autoplay: {
          delay: 8000,
        },
        navigation: {
            nextEl: '.lp-reviews__pagination-buttons .swiper-button-next',
            prevEl: '.lp-reviews__pagination-buttons .swiper-button-prev'
        },
        breakpoints: {
          320: {
              centeredSlides: true,
              slidesPerView: 1,
              spaceBetween: 14,
          },
          480: {
              slidesPerView: 1.26,
              spaceBetween: 14,
          },
          992: {
              centeredSlides: false,
              slidesPerView: 2.2,
              spaceBetween: bigScreenGap,
          },
          1200: {
              slidesPerView: bigScreenSlides,
              spaceBetween: bigScreenGap,
          },
          1500: {
              slidesPerView: bigScreenSlides,
              spaceBetween: bigScreenGap,
          },
          1920: {
              slidesPerView: bigScreenSlides,
              spaceBetween: bigScreenGap,
          }
        }     
      }
    );
  }
}
customElements.define("reviews-slider", ReviewsSlider);

/*============================================================================
  Product Reviews Slider
==============================================================================*/
class ProductReviews extends HTMLElement {
  constructor() {
    super();

    this.init();
  }

  init() {
    // Set up sliders
    this.sliderReviews = new Swiper(
      this.querySelector(".reviewSwiper"),{
        spaceBetween: 22,
        slidesPerView: 1,
        centeredSlides: true,
        loop: true,
        pagination: {
            el: document.querySelector('.product-reviews .swiper-pagination'),
            clickable: true,
        },
        breakpoints: {
            580: {
                slidesPerView: 3,
                spaceBetween: 40,
            },
            1000: {
 
                slidesPerView: 3,
                spaceBetween: 32,
                navigation: {
                    nextEl: document.querySelector('.nextEl'),
                    prevEl: document.querySelector('.prevEl'),
                }
            },
            1400: {
   
                slidesPerView: 5,
                spaceBetween: 32,
                navigation: {
                    nextEl: document.querySelector('.nextEl'),
                    prevEl: document.querySelector('.prevEl'),
                }
            }
        }       
      }
    );
  }
}
customElements.define("product-reviews", ProductReviews);

class ProductTabs extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.buttons = this.querySelectorAll('.tabs__button');
    this.panes = this.querySelectorAll('.tab-pane');
    this.init();
  }

  init() {
    this.buttons.forEach((btn) => {
      btn.addEventListener('click', () => this.activateTab(btn));
    });
  }

  activateTab(btn) {
    const targetId = btn.dataset.tab;
    this.buttons.forEach((b) => b.classList.remove('active'));
    this.panes.forEach((p) => p.classList.remove('active'));
    btn.classList.add('active');
    this.querySelector(`#${targetId}`).classList.add('active');
  }
}

customElements.define('product-tabs', ProductTabs);



class ReviewSlider extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    if (this.swiper) return; // prevent multiple init
    this.initSlider();
  }

  initSlider() {
    const slider = this.querySelector('.reviewsslider');
    const pagination = this.querySelector('.swiper-pagination');

    if (!slider) return;

    this.swiper = new Swiper(slider, {
      speed: 300,
      slidesPerView: 1,
      spaceBetween: 10,
      autoHeight: true, // mobile jump fix
      loop: true,

      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },

      pagination: {
        el: pagination,
        clickable: true,
      }
    });
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

customElements.define('review-slider', ReviewSlider);



/* landing review slider */
class LandReviewSlider extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.initSwiper();
  }
  initSwiper() {
    const swiperEl = this.querySelector('.land-reviews-slider');

    if (!swiperEl) return;

    this.swiper = new Swiper(swiperEl, {
      loop: true,
      spaceBetween: 15,
      slidesPerView: 1.2,
      pagination: {
        el: this.querySelector('.swiper-pagination'),
        clickable: true,
      },
      navigation: {
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev'),
      },
      breakpoints: {
        768: {
          slidesPerView: 2
        },
        1024: {
          slidesPerView: 4
        }
      }
    });
  }
}
customElements.define('land-reviews-slider', LandReviewSlider);
